import { computed, unref, type Ref } from 'vue'

export const useProgress = ({
  current,
  total,
  direction,
  fakeLenth,
}: {
  current: number | Ref<number | undefined | null>
  total: number | Ref<number | undefined | null>
  direction: 'horizontal' | 'vertical'
  fakeLenth: number | string
}) => {
  const progress = computed(() => {
    const cur = Number(unref(current) ?? 0)
    const tot = Number(unref(total) ?? 0)
    if (!isFinite(cur) || !isFinite(tot) || tot <= 0) return 0
    const ratio = cur / tot
    if (Number.isNaN(ratio)) return 0
    return Math.min(1, Math.max(0, ratio))
  })

  const scaleWH = computed(() => {
    return fakeLenth ? String(fakeLenth) : `${progress.value * 100}%`
  })

  const innnerStyles = computed(() => {
    return {
      w: direction === 'horizontal' ? scaleWH.value : '100%',
      h: direction === 'vertical' ? scaleWH.value : '100%',
    }
  })

  return { progress, scaleWH, innnerStyles }
}
